import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'color',
  renderInput: ({ value, onChange }) => (
    <div className="flex items-center gap-2">
      <input
        type="color"
        value={(value as string) || '#3B82F6'}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 w-14 cursor-pointer rounded-md border border-border-primary bg-bg-primary p-0.5"
      />
      <input
        type="text"
        value={(value as string) || ''}
        onChange={(e) => onChange(e.target.value || null)}
        placeholder="#000000"
        maxLength={7}
        className="w-28 rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm text-text-primary font-mono focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
      />
    </div>
  ),
  renderCell: (_field, value) => {
    if (!value) return '—';
    return (
      <div className="flex items-center gap-2">
        <span
          className="inline-block h-4 w-4 rounded-full border border-border-primary"
          style={{ backgroundColor: String(value) }}
        />
        <span className="text-xs font-mono text-text-secondary">{String(value)}</span>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    if (!/^#[0-9a-fA-F]{6}$/.test(String(value))) return 'Podaj kolor hex (#RRGGBB)';
    return null;
  },
  defaultValue: null,
});
